/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_CATALOG_LIST (state, val) {
    state.catalogList = val
  },
  UPDATE_CATALOG_LIST (state, val) {
    state.catalogList.push(...val);
  },
  UPDATE_CATALOG (state, catalog){    
    const i = state.catalogList.findIndex((e) => e.id == catalog.id)
    Object.assign(state.catalogList[i], catalog)
  },
  DELETE_CATALOG (state, catalog){
    const i = state.catalogList.findIndex((e) => e.id == catalog.id)
    state.catalogList.splice(i, 1)
  },
  ADD_CATALOG( state, catalog){
    state.catalogList.unshift(catalog);
  }
}
